import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';

import {
    useReelStore,
    useDeleteReelStore,
    useModalStore,
} from 'bdvp-common/src/hooks/store';
import {
    useDictionary,
} from 'bdvp-common/src/hooks/config';
import { constants as modalConstants } from 'bdvp-graphql/src/resolvers/modals';

import Component from '../components/DeleteModal';

const { DELETE_REEL_MODAL_NAME } = modalConstants;

const DeleteModal = ({
    onClose,
    onDelete,
}) => {

    const { modalHide } = useModalStore();
    const closeModal = useCallback(() => modalHide(DELETE_REEL_MODAL_NAME), [modalHide]);
    const { deleteReelId } = useDeleteReelStore();
    const {
        deleteReel,
        deleteReelLoading,
    } = useReelStore();
    const dictionary = useDictionary();
    const deleteReelHandler = useCallback(() => {

        deleteReel(deleteReelId);
        closeModal();
        onDelete();

    }, [
        deleteReelId,
        deleteReel,
        closeModal,
        onDelete,
    ]);

    const closeModalHandler = useCallback(() => {

        closeModal();
        onClose();

    },[
        closeModal,
        onClose,
    ]);

    return <Component
        dictionary={dictionary}
        closeModal={closeModalHandler}
        deleteReelHandler={deleteReelHandler}
        loading={deleteReelLoading}
    />;

};

DeleteModal.propTypes = {
    onClose: PropTypes.func,
    onDelete: PropTypes.func,
};

DeleteModal.defaultProps = {
    onClose: _noop,
    onDelete: _noop,
};

export default DeleteModal;
